// extracted by mini-css-extract-plugin
export default {"title":"Filters__title___SGQOt","container":"Filters__container___KZbeX"};